module.exports = "pages:\n- httprequest: ./topics/httprequest.md\n- httpresponse: ./topics/httpresponse.md"